import SkipTask from './src/main';

/* istanbul ignore next */
SkipTask.install = function(Vue) {
  Vue.component(SkipTask.name, SkipTask);
};

export default SkipTask;
